import React, { useState, useEffect } from 'react';
import CourseCard from './CourseCardList';
import coursecard from '../../assets/dashboard/coursecard.svg'
import Card from '../../components/common/Card';
import logo1 from "../../assets/dashboard/dot.png"
import logo2 from "../../assets/dashboard/soldproducts.png"
import { getAllCoursesByStaff } from '../../services/Staff/Staff';
import NotificationsDropdown from '../../components/common/notifications-dropdown';

import blue from '../../assets/dashboard/blue.png';
import dot from '../../assets/dashboard/dot.png';
import green from '../../assets/dashboard/green.png';
import totalCoursesIcon from '../../assets/dashboard/totalcourses-icon.png';

const dashboardData = [
  {
    title: "Total Courses",
    logo1: logo1,
    logo2: logo2,
    number: "0"
  },
  {
    title: "In Progress",
    logo1: logo1,
    logo2: logo2,
    number: "0"

  },
  {
    title: "Completed Courses",
    logo1: logo1,
    logo2: logo2,
    number: "0"

  },

]

const StaffCourses = () => {

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [addedCourse, setAddedCourse] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [courseToDelete, setCourseToDelete] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [courseToAssign, setCourseToAssign] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [allCoursesData, setAllCoursesData] = useState()
  const [allCourseLoading, setAllCourseLoading] = useState(false)
  const [assignStaffLoading, setAssignStaffLoading] = useState(false)
  const [searchedCourses, setSearchedCourses] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [cachedPages, setCachedPages] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardData, setCardData] = useState();


  // const handleSearch = () => {
  //   if (searchTerm.trim() === "") return;

  //   const filtered = allCoursesData.filter((item) =>
  //     item.title.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  //   setSearchedCourses(filtered);
  //   setIsSearching(true);
  // };

  const handleSearch = () => {
    if (!searchTerm.trim()) return;
    setIsSearching(true);
    console.log("searchTermsearchTerm", searchTerm)
    fetchCourseData(1, searchTerm);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        handleSearch();
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchedCourses([]);
    setIsSearching(false);
    fetchCourseData(1);
  };

  const [allStaffData, setAllStaffData] = useState(null);

  // const fetchData = async () => {
  //   const data = await getAllStaff();
  //   if (data) {
  //     console.log("Staff data >>>", data);
  //     setAllStaffData(data.staffs);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const fetchCourseData = async () => {
  //   setAllCourseLoading(true)
  //    let data = await getAllCourses();
  //    if(data){
  //     console.log("data>><<<>",data)
  //     setAllCoursesData(data?.data)
  //    }
  //   setAllCourseLoading(false)

  // }

  const fetchCourseData = async (page = 1, search = '') => {
    setAllCourseLoading(true);

    // Check cache if not searching
    if (!search && cachedPages[page]) {
      setAllCoursesData(cachedPages[page]);
      setCurrentPage(page);
      setAllCourseLoading(false);
      return;
    }

    try {
      const data = await getAllCoursesByStaff({ page, search });

      if (data?.data) {
        setAllCoursesData(data.data);
        setCurrentPage(page);
        setTotalPages(data.totalPages || 1);

        if (!search) {
          setCachedPages(prev => ({
            ...prev,
            [page]: data.data
          }));
        }
      }
      if (data) {
        const cards = [
          {
            title: "Total Courses",
            logo1: dot,
            logo2: totalCoursesIcon,
            count: data.totalCourses?.toString() || "0",
          },
          {
            title: "In Progress",
            logo1: green,
            logo2: totalCoursesIcon,
            count: data.totalInprogressCourses?.toString() || "0",
          },
          {
            title: "Completed Courses",
            logo1: blue,
            logo2: totalCoursesIcon,
            count: data.totalCompletedCourses?.toString() || "0",
          },
        ];
        setCardData(cards)

      }
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
      setAllCourseLoading(false);
    }
  };

  useEffect(() => {
    //  fetchCourseData()
    fetchCourseData(1)
  }, [])

  return (
    <div className="admin-dashboard p-4">

      <div className="row align-items-center mb-4 gx-3 my-4">
        <div className="col">
          <div className="search-container position-relative">
            <i
              className="bi bi-search position-absolute search-icon"
              style={{ cursor: 'pointer' }}
            // onClick={handleSearch}
            ></i>

            <input
              type="text"
              className="search-input w-100"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            // onKeyDown={handleKeyPress}
            />

            {isSearching && (
              <i
                className="bi bi-x-lg position-absolute"
                style={{
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#999',
                }}
                onClick={clearSearch}
              ></i>
            )}
          </div>
        </div>
        <div className="col-auto">
          <div className="d-flex align-items-center gap-3">
            {/* <button className="btn btn-light filter-btn">
              <i className="bi bi-funnel"></i>
            </button> */}
            {/* <button className="btn btn-light notification-btn position-relative">
              <i className="bi bi-bell"></i>
              <span className="notification-badge position-absolute"></span>
            </button> */}
            <NotificationsDropdown />

          </div>
        </div>


      </div>
      <div class="row pb-5">
        {
          cardData && cardData?.map((item) => {
            return (
              <Card col="4" Title={item.title} logo1={item.logo1} logo2={item.logo2} count={item?.count} />
            )
          })
        }
      </div>
      <div className="row g-4">


        {
          allCourseLoading ?

            <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div class="spinner-border spinner-border-sm" role="status"></div>
            </div>
            :
            <>
              {/* <CourseTable
              courses={allCoursesData}
              loading={allCourseLoading}
              onDeleteCourse={handleDeleteClick}
              onAssignStaff={handleAssignClick}
            // onEdit={handleEditClick}
            /> */}
              {
               allCoursesData && allCoursesData.length > 0 ?
               
               allCoursesData?.map((course, idx) => {
                  return (
                    <div className="col-md-4 mb-4" key={idx}>
                      <CourseCard
                        id={course?.course?._id}
                        image={course?.course?.thumbnail}
                        title={course?.course?.title}
                        subtitle={course?.subtitle}
                        instructor={course?.course?.instructor}
                        duration={course?.course?.totalDuration}
                        certificate={course?.certificate}
                        completionPercentage={course?.course?.completionPercentage}
                        score={course?.course?.score}
                      />
                    </div>
                  )
                })
                :
                <div
                  className="col-md-12"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '200px', // Adjust as needed
                    gap: '8px',
                    fontSize: '18px',
                    color: '#666'
                  }}
                >
                  <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                  No records found
                </div>
              }

              {/* <CourseTable
        courses={isSearching ? searchedCourses : allCoursesData }
        onDeleteCourse={handleDeleteClick}
        onAssignStaff={handleAssignClick}
      /> */}
      {
        allCoursesData && allCoursesData.length > 0 &&
        <nav className="d-flex justify-content-center mt-4">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                      className="page-link d-flex align-items-center justify-content-center"
                      onClick={() => fetchCourseData(currentPage - 1, isSearching ? searchTerm : '')}
                      disabled={currentPage === 1}
                    >
                      <i className="bi bi-chevron-left"></i>
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => fetchCourseData(page, isSearching ? searchTerm : '')}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button
                      className="page-link d-flex align-items-center justify-content-center"
                      onClick={() => fetchCourseData(currentPage + 1, isSearching ? searchTerm : '')}
                      disabled={currentPage === totalPages}
                    >
                      <i className="bi bi-chevron-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
      }
              
            </>
        }
      </div>
    </div>
  );
};

export default StaffCourses;